import { render, staticRenderFns } from "./ProductSubClassCreator.vue?vue&type=template&id=efcd6ed8&scoped=true"
import script from "./ProductSubClassCreator.vue?vue&type=script&lang=js"
export * from "./ProductSubClassCreator.vue?vue&type=script&lang=js"
import style0 from "./ProductSubClassCreator.vue?vue&type=style&index=0&id=efcd6ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcd6ed8",
  null
  
)

export default component.exports